namespace $.$$ {

	$mol_style_define( $shm_ba_file_picker, {
		Body: {
			minWidth: '280px',
			display: 'grid',
			gap: '12px',
			padding: $mol_gap.block,
		},

		Section: {
			display: 'grid',
			gap: '6px',
			padding: {
				top: '12px',
			},
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
			':first-child': {
				padding: {
					top: 0,
				},
				border: {
					top: {
						width: 0,
					},
				},
			},
		},

		Section_title: {
			color: $mol_theme.shade,
			font: {
				size: '13px',
				weight: 'bold',
			},
		},

		File_trigger_icon: {
			width: '16px',
			height: '16px',
			flex: {
				shrink: 0,
			},
		},

		File_trigger_more: {
			width: '16px',
			height: '16px',
			flex: {
				shrink: 0,
			},
		},

		File_title: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Local_files: {
			gap: '2px',
		},

		Local_file: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1fr) 32px',
			alignItems: 'center',
			gap: '4px',
		},

		Local_file_pick: {
			justifyContent: 'flex-start',
			minWidth: 0,
		},

		Local_file_delete: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: '32px',
			minHeight: '32px',
			padding: 0,
		},

		Local_file_delete_icon: {
			width: '14px',
			height: '14px',
		},

		Remote_files: {
			gap: '2px',
		},
	} )

	$mol_style_define( $shm_ba_file_picker_file_button, {
		justifyContent: 'flex-start',
		minWidth: 0,
		gap: '6px',
		File_icon: {
			width: '16px',
			height: '16px',
			flex: {
				shrink: 0,
			},
		},
		Title: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
		'@': {
			shm_ba_file_picker_file_current: {
				true: {
					color: $mol_theme.current,
				},
			},
		},
	} )

}
